import api from "@/api";

/**
 * LSP-18592 go-live (docs/plans/2026-09-23-LSP-18592-measurement-go-live.md, Decision 1): server-side
 * feature switches delivered on `GET /:app/me` as `config.featureFlags`. Every key is false unless the
 * API says otherwise, so a missing `me`, a missing `config`, or an older API all read as off.
 */
// live_translations: LSP-21125, Live Translations as Captions (recording lightbox Translation panel). Ships off.
// LSP-21826: mobile_app_banner gates the Open/Get app banner on the dashboard home page.
// LSP-22421: ios_home_screen_deprecation_warning gates the "this way of using the app is being retired"
// dialog shown after login in the iOS Home Screen web app. The API sends it false unless enabled.
// LSP-21987: org_upload_link gates the Organization Upload Link section in Organization Details and its
// settings-search entries. The API sends it false unless ORG_UPLOAD_LINK_ENABLED is on.
// LSP-21829: customer_review_page gates the Reviews page and the Google review reminder settings. Unlike the
// keys above the API sends it TRUE by default; CUSTOMER_REVIEW_PAGE_ENABLED=false turns the rating page off.
export type MeFeatureFlagKey =
	| "capture_evidence"
	| "capture_measure_ui"
	| "live_translations"
	| "mobile_app_banner"
	| "ios_home_screen_deprecation_warning"
	| "org_upload_link"
	| "customer_review_page";

export interface MeConfig {
	contentNotificationDelaySeconds?: number;
	featureFlags?: Record<string, boolean>;
	[key: string]: unknown;
}

export interface MeWithConfig {
	config?: MeConfig | null;
}

export function isMeFeatureFlagEnabled(me: MeWithConfig | null | undefined, key: MeFeatureFlagKey): boolean {
	return me?.config?.featureFlags?.[key] === true;
}

/** Synchronous read of the already-loaded `me`. Off when `me` has not loaded yet. */
export function isLoadedMeFeatureFlagEnabled(key: MeFeatureFlagKey): boolean {
	return isMeFeatureFlagEnabled((api as unknown as { _me?: MeWithConfig | null })._me, key);
}

/** Loads `me` if needed. Never rejects: any failure (unauthenticated, offline) reads as off. */
export async function loadMeFeatureFlag(key: MeFeatureFlagKey): Promise<boolean> {
	if (isLoadedMeFeatureFlagEnabled(key)) return true;
	try {
		return isMeFeatureFlagEnabled((await api.getMe()) as MeWithConfig | null, key);
	} catch (error) {
		console.warn("[FeatureFlags] Could not load me; treating flag as off", { key, error });
		return false;
	}
}
